export default {
  empty_list: 'Ingen kategorier endnu',
  uses_restaurant_open_times: 'Bruger restaurantens åbningstider',
  products_creation_disabled:
    'På grund af den aktive integration med {{integration}} er det ikke tilladt at oprette nye produkter. Hvis du skal ændre menuen, skal du foretage ændringerne i {{integration}} og synkronisere menuen.',
  buttons: {
    add_category: 'Tilføj kategori',
  },
  toasts: {
    something_went_wrong: 'Noget gik galt',
  },
};
